<template>
  <div id="app-wrap">
    <section id="main-cta">
      <div class="section-inner">
        <h1 class="title browser">TunnelBear for Chrome, Firefox and Edge</h1>
        <div class="container">
          <img-set
            classes="main-img smaller"
            :webpSrc="require('@/views/app-browser/images/apps_1_browser.webp')"
            :webpSrc2x="require('@/views/app-browser/images/apps_1_browser@2x.webp')"
            :imgSrc="require('@/views/app-browser/images/apps_1_browser.png')"
            :imgSrc2x="require('@/views/app-browser/images/apps_1_browser@2x.png')"
            alt="TunnelBear for Browser"/>
          <p>Your browsing and physical location are being tracked. It’s time to put a Bear in your browser and keep your data and location private from hackers, ISPs and malicious&nbsp;websites.</p>
          <div class="download-row">
            <div class="download-item btn-holder">
              <a :href="external.downloadLinks.chrome" class="btn btn-lg grey dl chrome"><div>Chrome</div></a>
              <p class="fine-print">Chrome 22+ <router-link :to="{name: 'chrome'}">Learn More</router-link></p>
            </div>
            <div class="download-item btn-holder">
              <a :href="external.downloadLinks.firefox" class="btn btn-lg grey dl firefox"><div>Firefox</div></a>
              <p class="fine-print">Firefox 58+</p>
            </div>
            <div class="download-item btn-holder">
              <a :href="external.downloadLinks.edge" class="btn btn-lg grey dl edge"><div>Edge</div></a>
              <p class="fine-print">Edge 114+</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <features>
      <template slot="content">
        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">Lightweight</h6>
            <p>Designed and developed as a slimmer, trimmer TunnelBear that’s just right for your&nbsp;browser.</p>
          </div>
        </div>

        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">Easy Installation</h6>
            <p>It couldn’t be easier. The quick installation will get you browsing privately in&nbsp;seconds.</p>
          </div>
        </div>

        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">Only Your Browser Data</h6>
            <p>With VPN-like capabilities, this extension only encrypts your web browser&nbsp;data.</p>
          </div>
        </div>

        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">Multiplatform</h6>
            <p>Linux, Chrome OS, macOS, Windows, no problem. TunnelBear for browsers works on any OS that Chrome, Firefox and Edge supports.</p>
          </div>
        </div>

        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">Simple Design</h6>
            <p>On, off, it’s that easy.  An extension designed to be so simple a bear could use&nbsp;it.</p>
          </div>
        </div>
      </template>
      <template slot="img">
        <img-set
          lazyload
          :webpSrc="require('@/views/app-browser/images/apps_2_browser.webp')"
          :webpSrc2x="require('@/views/app-browser/images/apps_2_browser@2x.webp')"
          :imgSrc="require('@/views/app-browser/images/apps_2_browser.png')"
          :imgSrc2x="require('@/views/app-browser/images/apps_2_browser@2x.png')"
          alt="TunnelBear for Browser" :width="682" :height="439"/>
      </template>
    </features>
    <audit-section></audit-section>
    <why-tunnelbear></why-tunnelbear>
    <download>
      <template slot="image">
        <img-set
          lazyload
          :webpSrc="require('@/images/apps/apps_footerbear.webp')"
          :webpSrc2x="require('@/images/apps/apps_footerbear@2x.webp')"
          :imgSrc="require('@/images/apps/apps_footerbear.png')"
          :imgSrc2x="require('@/images/apps/apps_footerbear@2x.png')"
          :width="440" :height="640"/>
      </template>
    </download>
  </div>
</template>

<script>
import features from '@/components/features/features'
import audit from '@/components/audit/audit'
import whyTunnelbear from '@/components/why-tunnelbear/why-tunnelbear'
import download from '@/components/download-cta/download-cta'

export default {
  name: 'browser',
  data () {
    return {}
  },
  components: {
    'audit-section': audit,
    'why-tunnelbear': whyTunnelbear,
    download,
    features
  }
}
</script>

<style scoped lang="stylus" src="./app-browser.styl" >
